import { ChangeDetectionStrategy, Component } from '@angular/core';
import { AssistantService } from './services/assistant.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AppComponent {
  title = 'coursesignage';
  readonly isOpen$ = this.assistantService.isOpen$;

  constructor(private assistantService: AssistantService) {}

  closeAssistant(): void { this.assistantService.close(); }
}
